import * as types from './ActionTypes';
import InitialState from 'Store/InitialState';
import produce from 'immer'
// import { loadStudentsView } from './Actions';

const createOtherLab = (state = InitialState.otherLabs, action) => {
    return produce(state, (draftState) => {
        draftState.push(action.payload)
    })
}

const updateOtherLab = (state = InitialState.otherLabs, action) => {
    return produce(state, (draftState) => {
        return draftState.map(item => item.id === action.payload.id ? action.payload : item)
    })
}

const deleteOtherLab = (state = InitialState.otherLabs, action) => {
    return produce(state, (draftState) => {
        return draftState.filter(item => item.id !== action.payload)
    })
}

const loadOtherLabs = (state = InitialState.otherLabs, action) => {
    return produce(state, (draftState) => {
        return action.payload
    })
}

export const OtherLabsReducer = (state = InitialState.otherLabs, action) => {
    //log.log("action", action, types)
    switch (action.type) {
        //   AUTH
        case types.LOAD_ALL_OTHERLABS:
            return loadOtherLabs(state, action)

        case types.CREATE_OTHERLAB:
            return createOtherLab(state, action);

        case types.UPDATE_OTHERLAB:
            return updateOtherLab(state, action);

        case types.DELETE_OTHERLAB:
            return deleteOtherLab(state, action);

        // case types.LOAD_STUDENT_VIEW:
        //     return loadStudentsView(state, action)
            
    }
    return state
}